import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GraphQLResponse } from '../../../types';
import { PROTOCOLS_LIST } from '../../query/protocols';
import { ProtocolStatus, ProtocolView } from '../../../types/protocol';

export default function useProtocols() {
  const { data: dataProtocols } = useQuery<GraphQLResponse<'protocols', ProtocolView[]>>(
    PROTOCOLS_LIST,
    {
      variables: {
        count: 30,
      },
    }
  );

  const protocols = dataProtocols?.protocols?.data;

  const protocolOptions = useMemo(
    () =>
      protocols
        ?.filter(c => c.status === ProtocolStatus.PUBLISHED)
        .map(c => ({
          value: c.id.toString(),
          label: c.name,
          data: c,
        })),
    [protocols]
  );

  return { protocols, protocolOptions };
}
